$(document).ready(function () {
  const $sample_atc_submit_event = async function ($form_data) {
    const $sample_addtocart_result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify($form_data),
    });

    const $atc_success_result = await $sample_addtocart_result.json();
    console.log("$sample_addtocart_result", $atc_success_result);
    if ($atc_success_result.items) {
      if (
        document.querySelector("cart-drawer") &&
        document.querySelector("cart-drawer").classList.contains("is-empty")
      )
        document.querySelector("cart-drawer").classList.remove("is-empty");
      const quickAddModal = document.querySelector("quick-add-modal");

      if (quickAddModal) {
        document.body.addEventListener(
          "modalClosed",
          () => {
            setTimeout(() => {
              document
                .querySelector("cart-drawer")
                .renderContents($atc_success_result);
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        document
          .querySelector("cart-drawer")
          .renderContents($atc_success_result);
      }
      flash("Product added!");
      load_cart();
    } else {
      console.error($atc_success_result);
    }
  };

  $(document).on("change", ".subscription-plan__variant-options input[type=radio][name^=Color-]", function(e) {
    let $match = $(`variant-radios .product-form__input input[value="${$(this).val()}"]`);
    $match.prop('checked', true);
    $match[0].dispatchEvent(new Event('change', { bubbles: true }));
  });

  $(document).on("click", ".trigger_btn", function (e) {
    e.preventDefault(), e.stopImmediatePropagation();

    let selectedColor = $(this).prev().find('.subscription-plan__variant-options input[type=radio][name^=Color-]:checked').val()
    let $match = $(`variant-radios .product-form__input input[value="${selectedColor}"]`);
    $match.prop('checked', true);
    $match[0].dispatchEvent(new Event('change', { bubbles: true }));

    let sample_product_atc_array = [];
    let vals = $('#' + $(this).attr("form")).find(".main_product_id").val();
    let $subscriptionPlan = $(this).parents(".subscription-plan__card");
    let $subscriptionPlans = $(this).parents(".subscription-plans");

    let mainProp = $subscriptionPlans.find(`variant-radios .product-form__input input:checked`).data("vals");
    let subText = $subscriptionPlan.data('property');

    let specialGift_Id = $subscriptionPlans
      .find(".special-gift-product")
      .attr("data-special-gift");

    if ($subscriptionPlan.data("value")) {
      if ($subscriptionPlan.data("selling-plan-id")) {
        var sellingPlanId = $subscriptionPlan.data("selling-plan-id");
        console.log("sellingPlanId", sellingPlanId);
      }
      sample_product_atc_array.push({
        id: String($subscriptionPlan.data('value')),
        quantity: 1,
        properties: {
          _Product_Plan: mainProp,
          _subscription: $subscriptionPlan.data("sub"),
          _subscription_plan: subText,
        },
        selling_plan: String(sellingPlanId),
      });
    }
    sample_product_atc_array.push({
      id: vals,
      quantity: 1,
      properties: {
        _Product_Plan: mainProp,
        _subscription_plan: subText,
      },
    });

    if (specialGift_Id) {
      sample_product_atc_array.push({
        id: specialGift_Id,
        quantity: 1,
        properties: {
          _Product_Plan: mainProp,
          _subscription_plan: subText,
        },
      });
    }

    let sample_product_atc_formData = {
      items: sample_product_atc_array,
      sections_url: window.location.pathname,
      sections: document
        .querySelector("cart-drawer")
        .getSectionsToRender()
        .map((section) => section.id),
    };
    $sample_atc_submit_event(sample_product_atc_formData);
  });

  $(document).on("click", ".cart_drawer_remove_btn", function (e) {
    e.preventDefault(), e.stopImmediatePropagation();
    let dataName = $(this).parents(".cart-item").data("remove");
    var data = { updates: {} };
    if (dataName == "") {
      let allData = $(this).parents(".cart-item").data("key");
      data.updates[allData] = 0;
    } else {
      let allData = $(`.cart-item[data-remove = ${dataName}]`);
      allData.each(function (index, elem) {
        let vals = $(this).data("key");
        data.updates[vals] = 0;
      });
    }
    jQuery.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: data,
      dataType: "json",
      success: function (cart) {
        $.getJSON("/cart.js", function (cart) {
          $(".cart-count-bubble span[aria-hidden='true']").text(
            cart.item_count
          );
          if (cart.item_count <= 0) {
            $("cart-drawer").addClass("is-empty");
          } else {
            $("cart-drawer").removeClass("is-empty");
          }
        });
        flash("Product deleted!");
        load_cart();
      },
    });
  });
});
